export default "__VITE_ASSET__Cl3tFSHh__"